import { style } from '@primeuix/styles/inputgroup';
import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-inputgroup'
};

export default BaseStyle.extend({
    name: 'inputgroup',
    style,
    classes
});
